<nav class="side-nav" role="navigation">
  <ul>
    <li>
      <cir-pub-nav-item [item]="homeNav" [additionalClasses]="'home-link'"></cir-pub-nav-item>
    </li>
    @for (nav of navigation; track nav; let i = $index) {
      <li>
        <h1 class="left-nav-section__heading" id="navgroup{{i}}">{{ nav.groupName }}</h1>
        <ul>
          @for (navItem of nav.navItems; track navItem) {
            <li>
              <cir-pub-nav-item  [item]="navItem" [additionalClasses]="''"></cir-pub-nav-item>
            </li>
          }
        </ul>
      </li>
    }
  </ul>
</nav>
